import { UserModel } from '../models/user.model';
import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { MembershipModel } from '../models/membership.model';
import { CommonHelper } from './common';

@Injectable({
    providedIn: 'root'
})
export class UserHelper {

    constructor() { }

    public getUser(): UserModel {
        if (localStorage.getItem('user')) {
            const user = new UserModel(JSON.parse(localStorage.getItem('user')));
            const userToken = jwt_decode(localStorage.getItem('token'));
            console.clear();
            if (typeof userToken.active_memberships !== 'undefined') {
                // tslint:disable-next-line: forin
                for (const i in userToken.active_memberships) {
                    const membership = new MembershipModel();
                    membership.id = userToken.active_memberships[i].id;
                    membership.date_exp = CommonHelper.getDate(userToken.active_memberships[i].date_exp);
                    membership.date_start = CommonHelper.getDate(userToken.active_memberships[i].date_start);
                    user.memberships.push(membership);
                }
            }
            return user;
        } else {
            return new UserModel();
        }
    }

}
